import * as React from 'react';
import { DeprecatedLink as Link } from '@lmn/design-system';
import type { DeprecatedLinkVariant as LinkVariant } from '@lmn/design-system';

type CallbackLinkProps = {
  onClick: (event: React.SyntheticEvent) => void;
  variant?: LinkVariant;
  appearance?: React.ComponentProps<typeof Link>['appearance'];
} & React.HTMLAttributes<HTMLElement>;

export function CallBackLink(props: CallbackLinkProps) {
  const { children, variant = 'accent', appearance = 'default', role, onClick, ...rest } = props;
  return (
    <Link
      variant={variant}
      appearance={appearance}
      role={role}
      onKeyPress={onClick}
      onClick={onClick}
      tabIndex={0}
      {...rest}
    >
      {children}
    </Link>
  );
}
